import "core-js/modules/es.array.index-of.js";
export default {
  name: "detail",
  data: function data() {
    return {
      imgUrl: ''
    };
  },
  created: function created() {
    var lang = this.getImgLang();
    this.imgUrl = require("../../assets/imgs/advert/detail_".concat(lang, ".png"));
  },
  beforeCreate: function beforeCreate() {
    document.title = this.$t("message.advert.VipFunctionsExplain"); // 标题国际化
  },
  methods: {
    getImgLang: function getImgLang() {
      var lang = (navigator.language || "").toLowerCase();

      if (lang === "zh-CN".toLowerCase()) {
        return "cn";
      } else if (lang === "zh-TW".toLowerCase()) {
        return "cn";
      } else if (lang.indexOf('fr') > -1) {
        return "fr";
      } else if (lang.indexOf('de') > -1) {
        return "de";
      } else if (lang.indexOf('it') > -1) {
        return "it";
      } else if (lang.indexOf('ja') > -1) {
        return "ja";
      } else if (lang.indexOf('es') > -1) {
        return "es";
      } else if (lang.indexOf('ru') > -1) {
        return "ru";
      }

      return "en";
    }
  }
};